<template>
  <p
    class="ocorrencia-item"
    style="font-weight: normal"
    @click="click"
  >
    <span class="title">
      {{this.contractTitle}}
    </span>
    <span class="sub-item">
      Protocolo: {{ row.protocolo }}
    </span>
    <span class="sub-item">
      Beneficiário: {{ row.beneficiario }}
    </span>
  </p>
</template>

<script>
export default {
  name: 'OcorrenciaItem',
  props: ['column', 'row'],
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  },
  computed: {
    contractTitle () {
      if (this.row.assunto) {
        return `${this.row.tipo_ocorrencia_label} - ${this.row.assunto}`
      }
      return this.row.tipo_ocorrencia_label
    }
  }
}
</script>
